module.exports = __webpack_public_path__ + "static/planeta_loving-5c04f0bca0029ac73c1100dc4d3abb68.png";